export default __webpack_public_path__ + "static/media/ForcedConvectionImg.65ed9633.png";